import { toExternalUrl } from '../../../utils/url';

function UrlListCell({ urls = [] }) {
  if (!urls.length) return <span>-</span>;

  return (
    <div style={{ textAlign: 'left', fontSize: '12px', lineHeight: '1.6' }}>
      {urls.map((url, i) => {
        const safeHref = toExternalUrl(url.reviewUrl);
        return (
          <div key={i}>
            {safeHref ? (
              <a
                href={safeHref}
                target="_blank"
                rel="noopener noreferrer"
                style={{ wordBreak: 'break-all', color: '#2563eb' }}
                onClick={(e) => e.stopPropagation()}
              >
                {url.reviewUrl}
              </a>
            ) : (
              <span style={{ wordBreak: 'break-all', color: '#6b7280' }}>
                {url.reviewUrl}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default UrlListCell;
